import { Link } from 'react-router-dom';
import { User } from '@supabase/supabase-js';
import { SubscriptionCard } from './SubscriptionCard';
import { FoundingSubscriptionCard } from './FoundingSubscriptionCard';
import { CancelSubscriptionSection } from './CancelSubscriptionSection';
import { CommunityCard } from './CommunityCard';
import { ReferralCard } from './ReferralCard';
import { NewsletterAccessCard } from '@/components/NewsletterAccessCard';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Subscription } from '@/hooks/useSubscription';
import { FoundingMembership } from '@/hooks/useFoundingMembership';

// Everything that belongs to the Alpha with AI Club, on its own tab (30 Oct 2026). Shown to Club members
// only (useClubMember); the Club is kept for them and closed to new sign-ups.
interface ClubTabProps {
  user: User;
  subscription: Subscription | null;
  isSubscribed: boolean;
  membership: FoundingMembership | null;
  isFoundingMember: boolean;
  hasFoundingBadge: boolean;
}

export function ClubTab({ user, subscription, isSubscribed, membership, isFoundingMember, hasFoundingBadge }: ClubTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-semibold text-foreground">Alpha with AI Club</h3>
          <p className="text-sm text-muted-foreground">Your membership, newsletter access and community profile.</p>
        </div>
        <Button asChild size="sm" className="gap-2">
          <Link to="/ai-investing-club/community">
            Open the Club <ArrowRight className="w-4 h-4" />
          </Link>
        </Button>
      </div>

      <FoundingSubscriptionCard
        membership={membership}
        isFoundingMember={isFoundingMember}
        hasBadge={hasFoundingBadge}
      />
      {!isFoundingMember && (
        <SubscriptionCard subscription={subscription} isSubscribed={isSubscribed} />
      )}
      {/* Real members can cancel; admin view-as shows a preview. */}
      {isSubscribed && subscription && (
        <CancelSubscriptionSection
          subscription={subscription}
          previewOnly={subscription.id.startsWith('view-as-')}
          onCancelled={() => window.location.reload()}
        />
      )}

      {(isSubscribed || isFoundingMember) && <NewsletterAccessCard />}

      <CommunityCard user={user} />
      <ReferralCard />
    </div>
  );
}
